import { Model } from 'core/models';

export class RequestState extends Model
{
    public id?: number;

    public code?: string;

    public name?: string;
}
